var map = {
	"./odep-icon-envelope.svg": [
		1553,
		487
	],
	"./odep-icon-logo.svg": [
		2984,
		784
	],
	"./odep-icon-pause.svg": [
		2314,
		839
	],
	"./odep-icon-play.svg": [
		2791,
		103
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 6698;
module.exports = webpackAsyncContext;